import { createContext, useContext } from 'react';

import { getTimeDistance, RangePickerValue } from 'src/components/card-range-picker/card-range-picker';
import { ReportRequest } from 'src/features/illegal-handle-report';
import { CaseReducerActions, useSlice } from 'src/lib/react-slice';

type ReportState = {
  search: ReportRequest & {
    rangePickerValue: RangePickerValue;
  };
  submittedSearch: ReportRequest & {
    rangePickerValue: RangePickerValue;
  };
};

const getInitialSearch = (): ReportState['search'] => {
  const dates = getTimeDistance('yesterday');
  return {
    rangePickerValue: dates,
    createAt_gt: dates[0].toISOString(), //时间根据选择改变
    createAt_lt: dates[1].toISOString(), //时间根据选择改变
    code: [], //违法类型代码
  };
};

const initReportState: ReportState = (() => {
  const search = getInitialSearch();
  return {
    search,
    submittedSearch: search,
  };
})();

const reportReducers = {
  setDateRange: (state: ReportState, dateRange: RangePickerValue) => {
    state.search.rangePickerValue = dateRange;
    state.search.createAt_gt = dateRange[0].startOf('day').toISOString();
    state.search.createAt_lt = dateRange[1].add(1, 'day').startOf('day').toISOString();
  },
  setCode: (state: ReportState, code: string) => {
    state.search.code = code ? [code] : [];
  },
  submitSearch: (state: ReportState) => {
    state.submittedSearch = { ...state.search };
  },
};

const ReportSearchContext = createContext<ReportState['search']>(null);
const SubmittedReportSearchContext = createContext<ReportState['submittedSearch']>(null);
const ReportDispatchContext = createContext<CaseReducerActions<typeof reportReducers>>(null);

export const IllegalHandleProvider = ({ children }) => {
  const [{ search, submittedSearch }, dispatch] = useSlice(reportReducers, initReportState);
  return (
    <ReportDispatchContext.Provider value={dispatch}>
      <ReportSearchContext.Provider value={search}>
        <SubmittedReportSearchContext.Provider value={submittedSearch}>
          {children}
        </SubmittedReportSearchContext.Provider>
      </ReportSearchContext.Provider>
    </ReportDispatchContext.Provider>
  );
};

export const useReportSearch = () => {
  const dispatch = useContext(ReportDispatchContext);
  const search = useContext(ReportSearchContext);
  const submittedSearch = useContext(SubmittedReportSearchContext);
  return [search, submittedSearch, dispatch] as const;
};
